export class Mobile {
    rate_package_id: string;
    contract_type: string;
    msisdn: string;
    old_iccid: string;
    old_contract_type: string;
    new_iccid: string;
    principal: boolean;
    service_provider_id: string;
    processing_date: string;
    sponsor_phone: string;
    convergent: boolean;
    sponsor: string;
    rate?: any;
}
